// Floating-бейдж в правом верхнем углу: текущая валюта отображения + клик
// переключает UZS↔USD. Один раз — никаких меню, никаких подтверждений.

import { haptic } from '../lib/telegram';
import { useViewCurrency } from '../lib/view-currency';

export function CurrencyToggle(): JSX.Element {
  const { viewCcy, toggle, usdRateUzs } = useViewCurrency();
  const disabled = !usdRateUzs && viewCcy === 'UZS'; // если хотим в USD, а курса нет — блокируем

  return (
    <button
      type="button"
      className={`ccy-toggle ${viewCcy === 'USD' ? 'usd' : 'uzs'}`}
      onClick={() => {
        if (disabled) return;
        haptic('light');
        toggle();
      }}
      disabled={disabled}
      aria-label={`Переключить валюту отображения. Сейчас: ${viewCcy}`}
      title={
        usdRateUzs
          ? `Курс: 1 USD = ${usdRateUzs.toLocaleString('ru', { maximumFractionDigits: 0 })} UZS`
          : 'Курс ещё не загружен'
      }
    >
      {viewCcy === 'UZS' ? 'сум' : '$'}
    </button>
  );
}
